import type { FC } from "react";

import { FormTextInput as UIFormTextInput } from "@jti/ui/components/ContactForm";
import { useEmailPattern } from "@jti/ui/hooks/useEmailPattern";
import { validationPatterns } from "@jti/ui/utils/validationPatterns";

import type { formTextInputInputs } from "./FormTextInput.builder";

export type FormTextInputProps = BuilderComponentProps<typeof formTextInputInputs>;

export const FormTextInput: FC<FormTextInputProps> = ({
  id,
  label,
  placeholder,
  required,
  requiredMessage,
  maxLength,
  minLength,
  disclaimer,
  matchingFieldId,
  validationErrorMessage = "",
  mathchingFieldErrorMessage = "",
  inputType,
  mode,
  isLocked,
}) => {
  const emailPattern = useEmailPattern();

  const patternByInputType = {
    email: emailPattern,
    phone: validationPatterns.PHONE_CONTACT_FORM_REGEX,
  } satisfies Record<string, RegExp>;

  const patternValue = patternByInputType[inputType as keyof typeof patternByInputType];

  return (
    <UIFormTextInput
      id={id}
      dataTestId={id}
      label={label}
      placeholder={placeholder}
      disclaimer={disclaimer}
      matchingFieldId={matchingFieldId}
      mathchingFieldErrorMessage={mathchingFieldErrorMessage}
      validationRules={{
        required: required ? requiredMessage || true : false,
        maxLength: maxLength ? { value: maxLength, message: validationErrorMessage } : undefined,
        minLength: minLength ? { value: minLength, message: validationErrorMessage } : undefined,
        pattern: patternValue
          ? {
              value: patternValue,
              message: validationErrorMessage,
            }
          : undefined,
      }}
      mode={mode}
      isLocked={isLocked}
    />
  );
};
